module.exports = __webpack_public_path__ + "static/media/background-16.9c301b3e.jpg";